import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const Delete = ({ itemId, apiEndpoint, rowKey, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const currentUserId = useSelector((state) => state.auth.id);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const deleteResponse = await axios.delete(`${apiEndpoint}/${itemId}`, {
        params: {
          userId: currentUserId
        }
      });
      
      if (deleteResponse.status === 200) {
        onDelete(itemId);
        console.log('Delete successful');
      } else {
        console.error('Delete failed with status:', deleteResponse.status);
        alert("Failed to delete the item. Please try again.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert(error.response?.data?.error || "An error occurred while deleting the item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDelete}
      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:bg-gray-400"
      disabled={loading}
    >
      {loading ? "Deleting..." : "Yes, Delete"}
    </button>
  );
};

export default Delete;